import ES from './es';
import EN from './en';

const summary = {
    ES,
    EN
};

export default summary;
